import Plausible from "plausible-tracker";
import railsEnv from "../railsEnv.js";

if (railsEnv === "production") {
  const { enableAutoPageviews } = Plausible({
    domain: "starthub.edeka",
  });

  enableAutoPageviews();
}
